import { render, staticRenderFns } from "./InstructionNote.vue?vue&type=template&id=0afb33c8&"
import script from "./InstructionNote.vue?vue&type=script&lang=js&"
export * from "./InstructionNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports